import { ForwardedRef, ReactNode, forwardRef } from 'react';
import cn from 'classnames';
import useModalStore from 'src/hooks/useModalStore';
import { GTAGPrefix } from 'src/hooks/useGTAG';
import useUserLocation from 'src/hooks/useUserLocation';

interface Props {
  disabled?: boolean;
  additionalSelectorChild?: ReactNode;
  selectorClassName?: string;
  gtagPrefix?: GTAGPrefix;
  onClick?: () => void;
}

const SelectorComponent = forwardRef(
  (props: Props, ref: ForwardedRef<HTMLButtonElement> = null) => {
    const {
      disabled = false,
      additionalSelectorChild,
      selectorClassName,
      onClick
    } = props;
    const updateModalsConfig = useModalStore(
      (state) => state.updateModalsConfig
    );
    const userLocation = useUserLocation();

    const openCitySelectModal = () => {
      updateModalsConfig({ 'city-selected-modal': true });
    };

    return (
      <button
        disabled={disabled}
        ref={ref}
        data-cy="city_select_button"
        className={cn(
          'flex justify-center items-center',
          'bg-transparent outline-none',
          selectorClassName
        )}
        onClick={() => {
          onClick();
          openCitySelectModal();
        }}
      >
        {additionalSelectorChild}
        <div className="min-w-[50px] line-clamp-2">{userLocation?.name}</div>
      </button>
    );
  }
);

SelectorComponent.displayName = 'SelectorComponent';
export default SelectorComponent;
